import { types, initialState } from 'store/MemberCommunication'

/**
 * Sets the member's selected request type
 *
 * @param {object} requestType
 */
export const setRequestType = requestType => {
  return {
    type: types.SET_REQUEST_TYPE,
    payload: requestType,
  }
}

/** Clears the member's selected request type */
export const clearRequestType = () => ({
  type: types.CLEAR_REQUEST_TYPE,
})

export const setBodyContent = request => {
  return {
    type: types.SET_BODY_CONTENT,
    payload: request,
  }
}

export const setPoptartHistory = section => {
  return {
    type: types.SET_POPTART_HISTORY,
    payload: section,
  }
}

export const setSelectedSpecialty = specialty => {
  return {
    type: types.SET_SELECTED_SPECIALTY,
    payload: specialty,
  }
}

/**
 * Remembers the Ash conversation that sent the member here, so the ticket they
 * are about to file can be joined back to it (ASH-915).
 *
 * In the store rather than read off the URL at submit time for the same reason
 * `selectedSpecialty` is: a hidden value picked up earlier in the flow and
 * folded into the Jira payload at the end. Set by `Inbox/Home`, cleared by
 * `RequestForm` once the ticket lands.
 *
 * @param {string} ashSessionId - A session id already through
 *   `sanitizeAshSessionId`, or '' for none.
 */
export const setAshSessionId = ashSessionId => {
  return {
    type: types.SET_ASH_SESSION_ID,
    payload: ashSessionId,
  }
}

export const prevHistory = () => {
  return {
    type: types.PREV_POPTART_HISTORY,
  }
}

export const clearPopTartHistory = () => {
  return {
    type: types.CLEAR_POPTART_HISTORY,
  }
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.SET_REQUEST_TYPE:
      return {
        ...state,
        requestType: {
          ...state.requestType,
          entity: payload,
        },
      }

    case types.CLEAR_REQUEST_TYPE:
      return {
        ...state,
        requestType: {
          ...state.requestType,
          entity: {
            title: '',
            id: '',
            fields: [],
          },
        },
      }

    case types.SET_BODY_CONTENT:
      return {
        ...state,
        poptart: {
          bodyContent: payload,
        },
      }

    case types.SET_POPTART_HISTORY:
      return {
        ...state,
        requestFlows: {
          ...state.requestFlows,
          history: [...state.requestFlows.history, payload],
        },
      }

    case types.SET_SELECTED_SPECIALTY:
      return {
        ...state,
        selectedSpecialty: {
          ...state.selectedSpecialty,
          entity: payload,
        },
      }

    case types.SET_ASH_SESSION_ID:
      return {
        ...state,
        ashSessionId: {
          ...state.ashSessionId,
          entity: payload,
        },
      }

    case types.PREV_POPTART_HISTORY:
      return {
        ...state,
        requestFlows: {
          ...state.requestFlows,
          history: state.requestFlows.history.slice(0, -1),
        },
      }

    case types.CLEAR_POPTART_HISTORY:
      return {
        ...state,
        requestFlows: {
          ...state.requestFlows,
          history: [],
        },
      }

    default:
      return state
  }
}
